import api from "@/api";
import { GET_PAYMENTS, GET_ACCRUALS } from "./types";

export default {
  [GET_PAYMENTS]: async ({ commit }) => {
    const resp = await api.payments.getPayments();

    commit(GET_PAYMENTS, await resp.data);
    return resp.data;
  },

  [GET_ACCRUALS]: async ({ commit }) => {
    const resp = await api.payments.getAccruals();

    commit(GET_ACCRUALS, await resp.data);
    return resp.data;
  }
};
